function DrinksMenuSketch({ type }) {
  if (!type || type === "none") return null;

  if (type === "cup") {
    return (
      <svg
        className="drinks-menu-sketch drinks-menu-sketch--cup"
        viewBox="0 0 80 70"
        aria-hidden="true"
      >
        <ellipse cx="34" cy="58" rx="22" ry="5" fill="none" stroke="currentColor" strokeWidth="1.2" />
        <path
          d="M16 22h36l-3 32a18 18 0 0 1-36 0L16 22z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
        />
        <path
          d="M52 28h8a8 8 0 0 1 0 16h-7"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
        />
        <path d="M28 10c0 4 2 5 2 9M36 8c0 5 2 6 2 11M44 11c0 3 1 4 1 8" fill="none" stroke="currentColor" strokeWidth="1" />
      </svg>
    );
  }

  if (type === "leaves") {
    return (
      <svg
        className="drinks-menu-sketch drinks-menu-sketch--leaves"
        viewBox="0 0 64 48"
        aria-hidden="true"
      >
        <path
          d="M8 40c12-2 18-14 22-28 6 10 10 18 26 24-14 4-24 2-32-4-4 6-10 8-16 8z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.1"
        />
        <path d="M30 12c2 8 4 14 8 20" fill="none" stroke="currentColor" strokeWidth="1" />
      </svg>
    );
  }

  if (type === "ice") {
    return (
      <svg
        className="drinks-menu-sketch drinks-menu-sketch--ice"
        viewBox="0 0 64 56"
        aria-hidden="true"
      >
        <rect x="18" y="28" width="22" height="18" rx="2" fill="none" stroke="currentColor" strokeWidth="1.2" transform="rotate(-8 29 37)" />
        <rect x="28" y="18" width="20" height="16" rx="2" fill="none" stroke="currentColor" strokeWidth="1.2" transform="rotate(12 38 26)" />
        <rect x="22" y="8" width="18" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.2" transform="rotate(-4 31 15)" />
      </svg>
    );
  }

  if (type === "bottle") {
    return (
      <svg
        className="drinks-menu-sketch drinks-menu-sketch--bottle"
        viewBox="0 0 36 72"
        aria-hidden="true"
      >
        <path
          d="M14 6h8v10l6 6v42a6 6 0 0 1-6 6H14a6 6 0 0 1-6-6V22l6-6V6z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
        />
        <path d="M12 34h12" fill="none" stroke="currentColor" strokeWidth="1" />
      </svg>
    );
  }

  if (type === "citrus") {
    return (
      <svg
        className="drinks-menu-sketch drinks-menu-sketch--citrus"
        viewBox="0 0 64 48"
        aria-hidden="true"
      >
        <ellipse cx="24" cy="26" rx="16" ry="14" fill="none" stroke="currentColor" strokeWidth="1.2" />
        <path d="M24 12v28M12 26h24M16 18c4 2 8 2 16 0M16 34c4-2 8-2 16 0" fill="none" stroke="currentColor" strokeWidth="1" />
        <ellipse cx="46" cy="30" rx="10" ry="9" fill="none" stroke="currentColor" strokeWidth="1.1" />
      </svg>
    );
  }

  if (type === "plate") {
    return (
      <svg
        className="drinks-menu-sketch drinks-menu-sketch--plate"
        viewBox="0 0 72 48"
        aria-hidden="true"
      >
        <ellipse cx="36" cy="26" rx="28" ry="14" fill="none" stroke="currentColor" strokeWidth="1.2" />
        <ellipse cx="36" cy="26" rx="18" ry="8" fill="none" stroke="currentColor" strokeWidth="1" />
        <path d="M22 18c4-6 10-8 14-8" fill="none" stroke="currentColor" strokeWidth="1" />
      </svg>
    );
  }

  if (type === "bowl") {
    return (
      <svg
        className="drinks-menu-sketch drinks-menu-sketch--bowl"
        viewBox="0 0 64 48"
        aria-hidden="true"
      >
        <path
          d="M10 20h44c0 14-8 22-22 22S10 34 10 20z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
        />
        <path d="M18 18c2-6 6-10 14-10s12 4 14 10" fill="none" stroke="currentColor" strokeWidth="1" />
      </svg>
    );
  }

  return null;
}

export default DrinksMenuSketch;
